export default {"src":"/_next/static/media/message-circle-more.bac26796.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};